import { useErrorsStore } from '../errors-store'

export function errorWatcherPlugin(context) {
  // Subscribe to store actions to catch errors.
  const errorsStore = useErrorsStore()
  context.store.$onAction(
    ({
      name, // name of the action
      store, // store instance, same as `someStore`
      args, // array of parameters passed to the action
      after, // hook after the action returns or resolves
      onError // hook if the action throws or rejects
    }) => {
      const startTime = Date.now()
      // this will trigger before an action on `store` is executed
      // this will trigger if the action succeeds and after it has fully run.
      // it waits for any returned promised
      after((result) => {})
      // this will trigger if the action throws or returns a promise that rejects
      onError((error) => {
        const e = {
          errorSourceStore: store.$id,
          errorSourceAction: name,
          errorSourceArgs: args,
          errorName: error.name,
          errorMessage: error.message
        }
        if (error.name === 'TypeError') {
          errorsStore.addErrorAction(e)
          // TODO: add error to error-store
        } else if (error.name === 'NetworkError') {
          console.error(`Network error in  ${name} should be handled by store`)
        }

        // console.warn(
        //   `Failed ${name} after ${Date.now() - startTime}ms.\nError: ${error}.`
        // )
      })
    }
  )
}
